import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IConfigurationByNameQueryVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']['input']>
}>

export type IConfigurationByNameQuery = {
  configuration?: { value: string } | null
}

export type IProjectConfigurationByNameQueryVariables = Types.Exact<{
  id: Types.Scalars['ObjectId']['input']
}>

export type IProjectConfigurationByNameQuery = {
  project?: {
    projectConfig?: {
      allowProjectCreation: boolean
      allowPhotos: boolean
      allowAnalytics: boolean
      allowFormsToggling: boolean
      allowDeliveriesToggling: boolean
      allowLogisticsToggling: boolean
      allowTrackerToggling: boolean
      allowMaterialsToggling: boolean
      allowMaterialResourcesToggling: boolean
      allowMaterials: boolean
      allowContainerUpdates: boolean
      allowTilesets: boolean
      allowEquipment: boolean
      allowStruxTags: boolean
      allowLocations: boolean
      tilesetsConfiguration?: {
        maxSize?: string | null
        maxNumber: number
      } | null
      formCategories?: {
        activity?: boolean | null
        delivery?: boolean | null
        environmental?: boolean | null
        equipment?: boolean | null
        material?: boolean | null
        quality?: boolean | null
        report?: boolean | null
        safety?: boolean | null
        site_communication?: boolean | null
      } | null
    } | null
  } | null
}

export const ConfigurationByNameDocument = gql`
  query ConfigurationByName($name: String) {
    configuration(name: $name) {
      value
    }
  }
`

/**
 * __useConfigurationByNameQuery__
 *
 * To run a query within a React component, call `useConfigurationByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useConfigurationByNameQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IConfigurationByNameQuery,
    IConfigurationByNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IConfigurationByNameQuery,
    IConfigurationByNameQueryVariables
  >(ConfigurationByNameDocument, options)
}
export function useConfigurationByNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IConfigurationByNameQuery,
    IConfigurationByNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IConfigurationByNameQuery,
    IConfigurationByNameQueryVariables
  >(ConfigurationByNameDocument, options)
}
export type ConfigurationByNameQueryHookResult = ReturnType<
  typeof useConfigurationByNameQuery
>
export type ConfigurationByNameLazyQueryHookResult = ReturnType<
  typeof useConfigurationByNameLazyQuery
>
export type ConfigurationByNameQueryResult = Apollo.QueryResult<
  IConfigurationByNameQuery,
  IConfigurationByNameQueryVariables
>
export const ProjectConfigurationByNameDocument = gql`
  query ProjectConfigurationByName($id: ObjectId!) {
    project(id: $id) {
      projectConfig {
        allowProjectCreation
        allowPhotos
        allowAnalytics
        allowFormsToggling
        allowDeliveriesToggling
        allowLogisticsToggling
        allowTrackerToggling
        allowMaterialsToggling
        allowMaterialResourcesToggling
        allowMaterials
        allowContainerUpdates
        allowTilesets
        allowEquipment
        allowStruxTags
        allowLocations
        tilesetsConfiguration {
          maxSize
          maxNumber
        }
        formCategories {
          activity
          delivery
          environmental
          equipment
          material
          quality
          report
          safety
          site_communication
        }
      }
    }
  }
`

/**
 * __useProjectConfigurationByNameQuery__
 *
 * To run a query within a React component, call `useProjectConfigurationByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectConfigurationByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectConfigurationByNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectConfigurationByNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    IProjectConfigurationByNameQuery,
    IProjectConfigurationByNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IProjectConfigurationByNameQuery,
    IProjectConfigurationByNameQueryVariables
  >(ProjectConfigurationByNameDocument, options)
}
export function useProjectConfigurationByNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IProjectConfigurationByNameQuery,
    IProjectConfigurationByNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IProjectConfigurationByNameQuery,
    IProjectConfigurationByNameQueryVariables
  >(ProjectConfigurationByNameDocument, options)
}
export type ProjectConfigurationByNameQueryHookResult = ReturnType<
  typeof useProjectConfigurationByNameQuery
>
export type ProjectConfigurationByNameLazyQueryHookResult = ReturnType<
  typeof useProjectConfigurationByNameLazyQuery
>
export type ProjectConfigurationByNameQueryResult = Apollo.QueryResult<
  IProjectConfigurationByNameQuery,
  IProjectConfigurationByNameQueryVariables
>
